import React from 'react';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';

class MainMenu extends React.PureComponent {
    render() {
        const { isMenuExpanded, handleMenuToggle } = this.props;
        return (
            <Drawer
                docked={false}
                open={isMenuExpanded}
                onRequestChange={handleMenuToggle}
            >
                <MenuItem>Projects</MenuItem>
                <MenuItem>People</MenuItem>
                <MenuItem>Files</MenuItem>
                <MenuItem>Settings</MenuItem>                
            </Drawer>
        );
    }
}

export default MainMenu;


// WEBPACK FOOTER //
// ./src/components/MainMenu/index.jsx